// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"61231b01","79":"c88e3d37","135":"f34dbad4","259":"74e175a4","264":"be367cf4","288":"ce608135","375":"31fceb12","426":"57ebe0bd","511":"329bb5c4","883":"fcbe081c","915":"87f66380"}[chunkId] + ".chunk.js";
};